import type { Root, Table } from 'mdast';
import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

import { dataIdMap } from './remark-constants';
import { setHTMLProperties } from './remark-helpers';

/**
 * This plugin extracts the original markdown source for table nodes and
 * attaches it as an HTML property. This allows the TableElement component to
 * use the original markdown instead of building it from the HTML.
 *
 * Uses the VFile source text (the actual text the AST was parsed from) so that
 * node positions always match, regardless of upstream text cleaning/streaming.
 */
export const remarkTable: Plugin<[], Root> = () => {
  return (tree, file) => {
    const sourceText = String(file);
    visit(tree, 'table', (node: Table) => {
      // Extract original markdown using the node's position
      if (node.position) {
        const { end, start } = node.position;
        // Extract the substring from the actual parsed source text
        const originalMarkdown = sourceText.slice(start.offset, end.offset);

        // Attach the original markdown as an HTML property
        setHTMLProperties(node, {
          [dataIdMap.tableMarkdown]: originalMarkdown,
        });
      }
    });
  };
};
